import React from 'react'

import { ButtonContainer, ButtonIcon, Badge } from './styles'

const ChatToggleButton = ({
    handleShowChat,
    handleHideChat,
    badgeCount,
    showChat,
}) => {
    const handleClick = () => {
        if (showChat) {
            handleHideChat()
        } else {
            handleShowChat()
        }
    }

    return (
        <ButtonContainer onClick={handleClick}>
            {!showChat && badgeCount > 0 && <Badge>{badgeCount}</Badge>}
            <ButtonIcon src="/assets/controls/latest/chat.svg" />
        </ButtonContainer>
    )
}

export default React.memo(ChatToggleButton)
